import { render } from "./PricingAndMarginExportDropDown.vue?vue&type=template&id=35a38490&scoped=true"
import script from "./PricingAndMarginExportDropDown.vue?vue&type=script&lang=js"
export * from "./PricingAndMarginExportDropDown.vue?vue&type=script&lang=js"

import "./PricingAndMarginExportDropDown.vue?vue&type=style&index=0&id=35a38490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a38490"]])

export default __exports__